import React from 'react';

const PageHeader = () => {
  return (
    <section
      className="relative pt-28 pb-20 md:pt-32 md:pb-28 min-h-[60vh] flex items-center"
      style={{
        backgroundImage: `url('/storage/gallery_images/slider-3.png')`, // same background as others
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Navy overlay */}
      <div className="absolute inset-0 bg-blue-900/70"></div>

      {/* Content */}
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center justify-center">
        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight drop-shadow">
          Patient Resources
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto mb-8 leading-relaxed drop-shadow">
          Empowering you with comprehensive eye health information and educational 
          resources for better vision care.
        </p>
      </div>
    </section>
  );
};

export default PageHeader;
